import { useRouter } from "next/router";
import React from "react";
import ProductListPage, {
  onFilterChange,
} from "../components/blocks/ProductListPage/ProductListPage";
import SinglesGamePicker from "../components/blocks/SinglesGamePicker/SinglesGamePicker";
import MetaElement from "../components/elements/MetaElement";

const Singles = (props) => {
  const router = useRouter();
  const query = router.query;

  return (
    <>
      <MetaElement
        pageId={
          query && query.game == 6
            ? "pkm-singles"
            : query.game == 3
            ? "ygo-singles"
            : query.game === 1
            ? "mtg-singles"
            : query.game === 18
            ? "op-singles"
            : query.game === 21
            ? "swu-singles"
            : "singles"
        }
      />
      {query && query.game ? (
        <ProductListPage
          {...props}
          view="singles"
          key={query}
          game={query ? query.game : 3}
        ></ProductListPage>
      ) : (
        <SinglesGamePicker />
      )}
    </>
  );
};

Singles.getInitialProps = async function (ctx) {
  const page = ctx.query.page || 1;
  const sort = ctx.query.sort || "new";
  const sortDirection = ctx.query.sortDirection || "DESC";
  const game = ctx.query.game || 3;

  let arrayFilters = Array.isArray(ctx.query.filters)
    ? ctx.query.filters
    : ctx.query.filters
    ? [ctx.query.filters]
    : [];

  const filters = (arrayFilters || []).map((filter) => {
    let splitFilter = filter.split("_");
    let key = splitFilter[0];
    let values = splitFilter[1].split(";");
    return {
      id: key,
      value: values,
    };
  });

  const opts = {
    page: page,
    pageSize: 24,
    sort,
    filters: filters,
    view: "singles",
    game,
  };

  const response = await onFilterChange(opts);

  return { ...response, page, sort, sortDirection, filterState: filters };
};

export default Singles;
